import CryptoJS from 'crypto-js';

// Function to derive key using PBKDF2
const deriveKey = (passphrase, salt) => {
  return CryptoJS.PBKDF2(passphrase, salt, {
    keySize: 256/32,
    iterations: 10000,
    hasher: CryptoJS.algo.SHA512
  });
};

// Function to encrypt data
export const encryptText = (plaintext, encryptionKey) => {
  try {
    // Generate random salt and IV
    const salt = CryptoJS.lib.WordArray.random(16);
    const iv = CryptoJS.lib.WordArray.random(16);
    
    // Derive key using PBKDF2
    const key = deriveKey(encryptionKey, salt);
    
    // Encrypt the data
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    
    // Combine salt + iv + ciphertext and encode as base64
    const ciphertext = encrypted.ciphertext;
    const combined = CryptoJS.lib.WordArray.create()
      .concat(salt)
      .concat(iv)
      .concat(ciphertext);
      
    return combined.toString(CryptoJS.enc.Base64);
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};